const COLORS: Record<string, string> = {
  Erdgeschoss:  "var(--unit-eg)",
  Obergeschoss: "var(--unit-og)",
  Zeltplatz:    "var(--unit-zp)",
  Dachgeschoss: "var(--unit-dg)",
  Leiterzimmer: "var(--unit-lz)",
};

const SHORT: Record<string, string> = {
  Erdgeschoss: "EG",
  Obergeschoss: "OG",
  Zeltplatz: "ZP",
  Dachgeschoss: "DG",
  Leiterzimmer: "LZ",
};

export function UnitChip({ name }: { name: string }) {
  const color = COLORS[name] ?? "var(--n-500)";
  const short = SHORT[name] ?? name;
  return (
    <span
      title={name}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        fontSize: 11,
        fontWeight: 600,
        padding: "1px 7px",
        borderRadius: 6,
        background: "var(--bg-subtle)",
        border: "1px solid var(--border)",
        color: "var(--fg)",
        whiteSpace: "nowrap",
      }}
    >
      <span style={{ width: 6, height: 6, borderRadius: 2, background: color }} />
      {short}
    </span>
  );
}
